module.exports = __webpack_public_path__ + "static/media/08a28a6e53f4279d0fccb2a9d7b6d4df.3cca5202.jpg";